import React from 'react';
import { Hero } from './components/Hero';
import { SalesContent } from './components/SalesContent';
import { Bonuses } from './components/Bonuses';
import { PurchaseSection } from './components/PurchaseSection';
import { Testimonials } from './components/Testimonials';
import { SocialProofPopup } from './components/SocialProofPopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-[#0a0a1a] text-white selection:bg-gold/30 selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <SalesContent data-id="element-3" />
      <Bonuses data-id="element-4" />
      <PurchaseSection data-id="element-5" />
      <Testimonials data-id="element-6" />

      <footer className="py-8 text-center text-gray-500 text-sm border-t border-gray-900 bg-black" data-id="element-7">
        <p data-id="element-8">
          © {new Date().getFullYear()} Entrenador de Futsal 360°. Todos los
          derechos reservados.
        </p>
        <p className="mt-2" data-id="element-9">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca comercial de FACEBOOK, Inc.
        </p>
      </footer>

      <SocialProofPopup data-id="element-10" />
    </div>;
}